const carpayHomeRoute = '/pay'

export default carpayHomeRoute
